module.exports = __webpack_public_path__ + "static/media/secao-1-bg.146783db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/secao-1-bg.jpg
// module id = 906
// module chunks = 5